var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":_vm.submit}},[_c('b-icon',{attrs:{"icon":"cloud-upload","aria-hidden":"true"}},[_vm._v("FTP")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }